module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    staticClass: "m-2",
    attrs: {
      "model": _vm.info,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "图片",
      "prop": "shop_img"
    }
  }, [_c('image-uploader', {
    model: {
      value: (_vm.info.shop_img),
      callback: function($$v) {
        _vm.$set(_vm.info, "shop_img", $$v)
      },
      expression: "info.shop_img"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "俱乐部名",
      "prop": "shop_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入群名"
    },
    model: {
      value: (_vm.info.shop_name),
      callback: function($$v) {
        _vm.$set(_vm.info, "shop_name", $$v)
      },
      expression: "info.shop_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "简介",
      "prop": "shop_intro"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "一句话介绍你的群（最长14个字符）"
    },
    model: {
      value: (_vm.info.shop_intro),
      callback: function($$v) {
        _vm.$set(_vm.info, "shop_intro", $$v)
      },
      expression: "info.shop_intro"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "描述",
      "prop": "shop_description"
    }
  }, [_c('wang-editor', {
    model: {
      value: (_vm.info.shop_description),
      callback: function($$v) {
        _vm.$set(_vm.info, "shop_description", $$v)
      },
      expression: "info.shop_description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "城市"
    }
  }, [_c('city-selector', {
    model: {
      value: (_vm.info.city_id),
      callback: function($$v) {
        _vm.$set(_vm.info, "city_id", $$v)
      },
      expression: "info.city_id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "类型",
      "prop": "shop_type"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.info.shop_type),
      callback: function($$v) {
        _vm.$set(_vm.info, "shop_type", $$v)
      },
      expression: "info.shop_type"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 7,
      "label": "俱乐部"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标签",
      "prop": "tags"
    }
  }, _vm._l((_vm.info.tags), function(tag, index) {
    return _c('el-tag', {
      key: tag,
      staticClass: "form-item-tag",
      attrs: {
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.removeTag(index)
        }
      }
    }, [_vm._v(_vm._s(tag))])
  }), 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "显示文章",
      "prop": "display_article"
    }
  }, [_c('el-switch', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.info.display_article),
      callback: function($$v) {
        _vm.$set(_vm.info, "display_article", $$v)
      },
      expression: "info.display_article"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态",
      "prop": "shop_status"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.info.shop_status),
      callback: function($$v) {
        _vm.$set(_vm.info, "shop_status", $$v)
      },
      expression: "info.shop_status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("审核")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("上线")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("下线")])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": function () { return _vm.$router.back(); }
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-662cd8f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/group/group-edit.vue
// module id = 801
// module chunks = 1